export default __webpack_public_path__ + "static/2_9-45917a3f90ac7ee77d1cca3d6f39bbb2.png";